const loadInitialState = () =>
  App.shop_list ? {items: App.shop_list.items} : {}

const shopList = (state = {items: []}, action) => {
  switch (action.type) {
    case "SHOP.INIT":
    case "SHOP_INVENTORY.INIT":
      return loadInitialState();
    default:
      return state;
  }
}

export default shopList;
